import { Component } from "@angular/core";
import { Functionality } from "src/app/shared/constants/functionality.constants";
import { GrafanaService } from "src/app/shared/services/grafana.service";
import { PermissionService } from "src/app/shared/services/permission.service";
import { OrganizationService } from "src/app/epicare-public/administration/domain/services/organization.service";

@Component({
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.scss"],
})
export class LandingPageComponent {
  constructor(
    private readonly permissionService: PermissionService,
    private readonly organizationService: OrganizationService,
    private readonly grafanaService: GrafanaService
  ) {}

  /**
   * Whether the user's role allows uploading data
   */
  get canImportData(): boolean {
    return this.permissionService.isEnabled(Functionality.IMPORT_DATA);
  }

  /**
   * Whether the user's role allows opening Grafana, i.e. seeing the analytics
   */
  get canOpenGrafana(): boolean {
    return this.grafanaService.canOpenGrafana();
  }

  /**
   * Whether the user's role grants access to the administration section
   */
  get canAccessAdministration(): boolean {
    return this.permissionService.canAccessAdministration;
  }

  /**
   * Whether the user administrates every organization (SuperAdmin) rather than only their own (admin)
   */
  get canViewAllOrganizations(): boolean {
    return this.organizationService.canGetAllOrganizations();
  }

  /**
   * Open the analytics, i.e. Grafana in a new tab, already logged in
   */
  openGrafana(): void {
    this.grafanaService.openGrafana();
  }
}
